module.exports = __webpack_public_path__ + "img/drLinkImg.7238a62d.svg";